import { useMemo } from 'react';
import { useAuth } from '@/auth/authContext';

/**
 * Ordered list of admin routes with their required permission names.
 * Uses the same permission name strings as the Sidebar navigation.
 * The first route the user has permission for becomes their default landing page.
 */
const ROUTE_PERMISSIONS = [
  { path: '/admin/dashboard', permission: 'View Dashboard' },
  { path: '/admin/users/list', permission: 'View Users' },
  { path: '/admin/config/countries', permission: 'View Countries' },
  { path: '/admin/drivers', permission: 'View Drivers' },
  { path: '/admin/riders', permission: 'View Riders' },
  { path: '/admin/vehicle-categories', permission: 'View Vehicle Categories' },
  { path: '/admin/promotions', permission: 'View Promotions' },
  { path: '/admin/referral-campaigns', permission: 'View Referral Campaigns' },
  { path: '/admin/disputes', permission: 'View Disputes' },
  { path: '/admin/reports', permission: 'View Reports' },
  { path: '/admin/audit-logs', permission: 'View Audit Logs' },
  { path: '/admin/distance-wait-time-settings', permission: 'View Distance & Wait Settings' },
  { path: '/admin/settings/email', permission: 'View Email Settings' },
  { path: '/admin/settings/sms', permission: 'View SMS Settings' },
];

export function useDefaultRoute(): string {
  const { user } = useAuth();

  return useMemo(() => {
    // Security > Change Password is the default landing page for all users
    return '/admin/security/change-password';
  }, [user]);
}
